import { MarketViewComponent } from './market-view.component';
import { PropertyViewComponent } from './property-view.component';
export { ViewComponent, ViewType, MapState } from './view.component';
import { LandingComponent } from './landing/landing.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { LeaderboardAnchorDirective } from './leaderboard/leaderboard-anchor.directive';
import { LandingAnchorDirective } from './landing/landing-anchor.directive';

export const VIEWS = [
  MarketViewComponent,
  PropertyViewComponent,
  LandingComponent,
  LeaderboardComponent
];

export const DIRECTIVES = [
  LeaderboardAnchorDirective,
  LandingAnchorDirective
]

export {
  MarketViewComponent,
  PropertyViewComponent,
  LandingComponent,
  LeaderboardComponent,
  LeaderboardAnchorDirective,
  LandingAnchorDirective
}



// WEBPACK FOOTER //
// ./src/app/main/views/index.ts